module.exports = __webpack_public_path__ + "media/images/banners/banner4-d04ee068dba263779028b74045e434d3.jpg";